import React from 'react'
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";

export const CardInfo = () => {
  const { T } = useApp();

  return (
    <Container>
      <ContainerView background="transparent">
        <TitlePage>{T("Card information")}</TitlePage>
        <div className="flex justify-between items-start w-full mt-[32px] lg:gap-12">
          <div className="w-full block grow-1">
              <div className="mt-4 formWraper-change-card">
                {/* <Elements stripe={stripePromise}>
                    <Form />
                </Elements> */}
              </div>
          </div>
        </div>
      </ContainerView>
    </Container>
  );
};
